import React from 'react';

import { FormControl, FormHelperText } from '@material-ui/core';
import { ConfigHeader } from '@sierralabs/forms-ui';
import ConfigCard from '@sierralabs/forms-ui/dist/config/components/ConfigCard';
import ConfigContent from '@sierralabs/forms-ui/dist/config/components/ConfigContent';
import { Shape } from '@sierralabs/workflow';

import { WorkflowDto } from '../Workflow.interface';
import FieldSelector from './FieldSelector';

export interface EditableFieldSectionProps {
  shape: Shape;
  workflowDto: WorkflowDto;
  onChange?: (fields: string[]) => void;
}

const EditableFieldSection: React.FC<EditableFieldSectionProps> = (
  props: EditableFieldSectionProps
) => {
  const { shape, workflowDto, onChange } = props;
  const allowedFields: string[] = shape.data?.meta?.allowedFields || [];
  return (
    <ConfigCard>
      <ConfigHeader>Editable Fields</ConfigHeader>
      <ConfigContent>
        <FormControl className='form-control'>
          <FieldSelector
            onChange={onChange}
            fields={allowedFields}
            type={workflowDto.taskType?.targetEntity}
          />
          <FormHelperText className='pad-left'>
            Checked fields will be editable in this State.
          </FormHelperText>
        </FormControl>
      </ConfigContent>
    </ConfigCard>
  );
};

export default EditableFieldSection;
